import React, { useState, createContext, useContext, useCallback, useEffect } from 'react';

 
import { useConfiguration } from '../Configuration';
import { traductionList } from 'src/utils/traductions';

interface ILanguage {
  title: string;
  code: string;
}


interface ITranslatePropertyProps {
   item: Record<string,any>;
  property: string;
  language : string;
}

interface ITranslateProperty {
  (ITranslatePropertyProps) : string
}


interface LanguageContextData {
  changeLanguage(language: string): void;
  translate(message?: string | React.ReactNode): string;
  language: string;
  setAvailableLanguages(languages: Array<ILanguage>): void;
  availableLanguages: Array<ILanguage>;
  translateProperty : ITranslateProperty;
}

const LanguageContext = createContext<LanguageContextData>(
  {} as LanguageContextData,
);

const LanguageProvider: React.FC<any> = ({ children }) => {

  const { platformConfiguration } = useConfiguration();

  const { authTitle } = platformConfiguration;

  const [language, setLanguage] = useState(() => {
    const selected = localStorage.getItem(`@${authTitle}:language`);

    return selected || 'ptBr';
  });
 

  const validLanguages: Record<string, any> = {
    ptBr: true,
    en: true,
    es: true,
  };

  const [availableLanguages, setAvailableLanguages] = useState<Array<ILanguage>>([{ title: 'PT', code: 'ptBr' }, { title: 'EN', code: 'en' },   { title: 'ES', code: 'es' }]);

  const translate = (message?: string): string => {

    return translateString(message);

  };

  const translateString = (message?: string) => {


    if (!message) {
      return '';
    }

    const responseIndex = traductionList.findIndex(
      text => text.ptBr && (text.ptBr)?.toString()?.toLowerCase() === message?.toString()?.toLowerCase()
    );

    if (responseIndex && traductionList[responseIndex]) {
      return traductionList[responseIndex][language] || message;
    }

    return message;

  }

    const translateProperty : ITranslateProperty = ({item, property, language}) => {


    if (!item[property]) {
      return '';
    }

    return item?.[`${property}_${language}`] ? item?.[`${property}_${language}`] : item?.[`${property}`]
 

  }

  const changeLanguage = useCallback(
    (nextLanguage: string) => {
      if (validLanguages[nextLanguage] === true) {
        localStorage.setItem(`@${platformConfiguration?.authTitle}:language`, nextLanguage);
        setLanguage(nextLanguage);
      } else {
        localStorage.setItem(`@${platformConfiguration?.authTitle}:language`, 'ptBr');
      }
    },
    [validLanguages],
  );


  const getCurrentLanguage = () => {
    
    const current = localStorage.getItem(`@${platformConfiguration?.authTitle}:language`);
 
    setLanguage( current || 'ptBr')


  }

  useEffect(() => {
getCurrentLanguage()
  },[platformConfiguration?.authTitle])

  return (
    <LanguageContext.Provider value={{ translateProperty, availableLanguages, setAvailableLanguages, changeLanguage, translate, language }}>
      {children}
    </LanguageContext.Provider>
  );
};

function useLanguage(): LanguageContextData {
  const context = useContext(LanguageContext);

  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }

  return context;
}

export { useLanguage, LanguageProvider };
